module.exports = __webpack_public_path__ + "img/banner.6041d8fa.jpg";